<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				resource: 'departments',
				modal: {
					selector: 'department-edit'
				},
				data: null,
				statuses: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getStatuses()
			},
			open(data) {
				this.data = data
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getStatuses: function() {
				this.$http.get('admin/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			clearData: function() {
				this.data = null
			},
			validateData() {
				if(this.data.name) {
					return true
				} else {
					return false
				}
			},
			update: function() {
				if(this.validateData()) {
					var loading = Ladda.create(document.querySelector('#btn-update'));
					loading.start();
					var api = 'admin/'+this.resource+'/'+this.data.id
					this.$http.put(api, this.data)
					.then(response => {
						this.close()
						this.clearData()
						this.$emit('reload')
						loading.start()
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type
						})
					}).catch(function(response) {
						console.log(response)
						loading.stop();
					})
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/departments/views/Edit.vue